import client from "../../axiosClient/client";
import { YieldType } from "../../globalTypes";

interface SendYieldValueArgs {
  isin: string;
  quoteFeedId: string;
  yieldType: YieldType;
  yieldValue: string;
  isFallback?: boolean;
}

export const sendYieldValue = async ({ isin, quoteFeedId, yieldType, yieldValue, isFallback = false }: SendYieldValueArgs) => {
  const url = "/feed/quote";
  const body = {
    isin,
    data_type: yieldType,
    value: Number(yieldValue),
    quote_feed_id: quoteFeedId,
    timestamp: new Date().toISOString(),
    is_fallback: isFallback,
  };

  const res = await client
    .post({ url, data: body })
    .then((res) => ({ status: "ok", statusText: "Successfully sent", yieldType, statusCode: res.status }))
    .catch((err) => ({ status: "error", statusText: err.message, yieldType, statusCode: err.response.status }));

  return res;
};
